function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z",
  fill: "url(#facebook-event_svg__paint0_linear_427_109507)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.836 10.125h-1.042V8.042h-2.083v2.083H15.294V8.042h-2.083v2.083h-1.042a2.09 2.09 0 00-2.083 2.083v16.667a2.09 2.09 0 002.083 2.083h16.667a2.09 2.09 0 002.083-2.083V12.208a2.09 2.09 0 00-2.083-2.083zm0 18.75H12.169V15.333h16.667v13.542z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "facebook-event_svg__paint0_linear_427_109507",
  x1: 20,
  y1: 38.831,
  x2: 20,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0062E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#19AFFF"
})));

function SvgFacebookEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgFacebookEvent;